import { render } from "./VendorInvoiceDetails.vue?vue&type=template&id=35d1693e&ts=true"
import script from "./VendorInvoiceDetails.vue?vue&type=script&lang=ts"
export * from "./VendorInvoiceDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__